import styled, { css } from 'styled-components';
import { white } from '../../theme/colors';
import themeSizes from "../../theme/themeSizes";

const Card = styled.section`
    width: ${props => props.width ? props.width : '100%'};
    height: ${props => props.height ? props.height : '100%'};
    margin-right: 24px;
    margin-bottom: 16px;
    margin: ${props => props.margin && props.margin};
    background: ${white};
    border-radius: 12px;
    border: 1px solid #E2E8F0;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 0 4px 15px -2px rgba(91, 127, 220, 0.05), 0 2px 6px -1px rgba(91, 127, 220, 0.03);
    overflow: hidden;
    position: relative;
    
    @media ${themeSizes.mobile}{
        width: 100% !important;
        margin-right: 0 !important;
        margin-bottom: 0 !important;
        min-height: 100px !important;
        height: auto !important;
        padding-bottom: 12px !important;
    }
    
    ${props => props.clickable &&
        css`
            cursor: pointer;
            
            &:hover {
                box-shadow: 0 20px 25px -5px rgba(91, 127, 220, 0.12), 0 10px 10px -5px rgba(91, 127, 220, 0.06);
                transform: translateY(-4px);
                border-color: #4770C155;
            }
        `
    }

    ${props => props.extraStyles && css`
        ${props.extraStyles}
    `}
`;

export default Card;

